import React,{useEffect, useState} from 'react';
import Tag from '@material-ui/icons/LocalOffer';
import Arrow from '@material-ui/icons/TrendingFlat';
import { makeStyles } from '@material-ui/core/styles';

import pattern from "../../Images/pattern3.png";
import pattern2 from "../../Images/pattern.png";
import project1 from "../../Images/project1.png";
import project2 from "../../Images/project2.png";
import project3 from "../../Images/project3.png";
import project4 from "../../Images/project4.png";
import project5 from "../../Images/project5.png";
import project6 from "../../Images/project6.png";
import video1 from "../../Videos/video1.mp4";
import video2 from "../../Videos/video2.mp4";
import video3 from "../../Videos/video3.mp4";
import video4 from "../../Videos/video4.mp4";
import video5 from "../../Videos/video5.mp4";
import video6 from "../../Videos/video6.mp4";

const useStyle = makeStyles({
    Tag:{
        fontSize: "18px",
        ['@media (max-width:1180px)']: {
            fontSize: "15px"
        },
        ['@media (max-width:500px)']: {
            fontSize: "12px"
        },
    },
});

export default function Work(){
    const[offsetY, setOffsetY] = useState(0);
    const handleScroll = () => setOffsetY(window.pageYOffset);
    const [media, setMedia] = useState({
        matches: window.matchMedia("(max-width: 1180px)").matches
    });
    const classes = useStyle();

    useEffect(() => {
        window.addEventListener("scroll", handleScroll);
        
        const handler = e => setMedia({matches: e.matches});
        window.matchMedia("(max-width: 1180px)").addListener(handler);

        return () =>window.removeEventListener("scroll", handleScroll);
    },[])

    return(
        <div className="Work">
            <div className="work-intro" data-aos="fade-right">
                <h2 className="work-Title">I design full stack products, build beautiful websites, and compose inspiring user interfaces.</h2>
                <p className="work-slogan">I always take inspirations from others and tried to build/develop it live through imaginations and creativity.</p>
            </div>
            {media.matches && (
                <div>
            <div className="portfolio">
                <div className="project-div"  data-aos="fade-up">
                    <div className="project-img">
                        <img src={project1} className="proimg" />
                        <video className="proimg hover-img" autoPlay muted loop>
                  		    <source src={video1} type="video/mp4" />
                  	    </video>
                    </div>
                    <button className="pro-tag"><Tag className={classes.Tag} />UI,Design</button>
                    <div className="project-des" >
                        <h3 className="des-head">A Product Landing Page with smooth animation.</h3>
                        <p className="des-link"><a href="https://github.com/Vikalp2502/Shoes-Nike-Landing-Page" className="a-link">View on Github <Arrow/></a></p>
                    </div>
                </div>
                <div Class="project-div"  data-aos="fade-up">
                    <div className="project-img">
                        <img src={project2} className="proimg" />
                        <video className="proimg hover-img" autoPlay muted loop>
                  		    <source src={video2} type="video/mp4" />
                  	    </video>
                    </div>
                    <button className="pro-tag"><Tag className={classes.Tag} />Design</button>
                    <div className="project-des">
                        <h3 className="des-head">A Web Design Portfolio Layout with svg animations.</h3>
                        <p className="des-link"><a href="https://github.com/Vikalp2502/Web-Design-Portfolio" className="a-link">View on Github <Arrow/></a></p>
                    </div>
                </div>
            </div>
            <div className="portfolio sec-port">
                <div className="project-div"  data-aos="fade-up">
                    <div className="project-img">
                        <img src={project3} className="proimg" />
                        <video className="proimg hover-img" autoPlay muted loop>
                  		    <source src={video3} type="video/mp4" />
                  	    </video>
                    </div>
                    <button className="pro-tag"><Tag className={classes.Tag} />Development</button>
                    <div className="project-des">
                        <h3 className="des-head">AlgoSort - A Visualizer of all common sorting algorithms.</h3>
                        <p className="des-link"><a href="https://github.com/Vikalp2502/AlgoSort-Sorting-Visualiser" className="a-link">View on Github <Arrow/></a></p>
                    </div>
                </div>
                <div Class="project-div"  data-aos="fade-up">
                    <div className="project-img">
                        <img src={project4} className="proimg" />
                        <video className="proimg hover-img" autoPlay muted loop>
                  		    <source src={video4} type="video/mp4" />
                  	    </video>
                    </div>
                    <button className="pro-tag"><Tag className={classes.Tag} />Development</button>
                    <div className="project-des">
                        <h3 className="des-head">Shortest PathFinder Visualizer with 4 different algorithms.</h3>
                        <p className="des-link"><a href="https://github.com/Vikalp2502/PathFinding-Visualizer" className="a-link">View on Github <Arrow/></a></p>
                    </div>
                </div>
            </div>
            <div className="portfolio sec-port">
                <div className="project-div"  data-aos="fade-up">
                    <div className="project-img">
                        <img src={project5} className="proimg" />
                        <video className="proimg hover-img" autoPlay muted loop>
                  		    <source src={video5} type="video/mp4" />
                  	    </video>
                    </div>
                    <button className="pro-tag"><Tag className={classes.Tag} />Development</button>
                    <div className="project-des">
                        <h3 className="des-head">A Sports Landing Page with mouseover effect.</h3>
                        <p className="des-link"><a href="https://github.com/Vikalp2502/Tribute-to-msd" className="a-link">View on Github <Arrow/></a></p>
                    </div>
                </div>
                <div Class="project-div"  data-aos="fade-up">
                    <div className="project-img">
                        <img src={project6} className="proimg" />
                        <video className="proimg hover-img" autoPlay muted loop>
                  		    <source src={video6} type="video/mp4" />
                  	    </video>
                    </div>
                    <button className="pro-tag"><Tag className={classes.Tag} />Design</button>
                    <div className="project-des">
                        <h3 className="des-head">A Gaming Landing Page with split blur effect.</h3>
                        <p className="des-link"><a href="https://github.com/Vikalp2502/CODM-landing_page" className="a-link">View on Github <Arrow/></a></p>
                    </div>
                </div>
            </div>
            <div className="social-footer" data-aos="fade-up">
                <a href="https://github.com/vikalp2502"><button className="social-btn">See more Work 💼</button></a>
            </div>
            </div>
            )}
            {!media.matches && (
                <div>
            <div className="portfolio">
                <div className="project-div">
                    <div className="project-img">
                        <img src={project1} className="proimg" />
                        <video className="proimg hover-img" autoPlay muted loop>
                  		    <source src={video1} type="video/mp4" />
                  	    </video>
                    </div>
                    <button className="pro-tag"><Tag className={classes.Tag} />UI,Design</button>
                    <div className="project-des" >
                        <h3 className="des-head">A Product Landing Page with smooth animation.</h3>
                        <p className="des-link"><a href="https://github.com/Vikalp2502/Shoes-Nike-Landing-Page" className="a-link">View on Github <Arrow/></a></p>
                    </div>
                </div>
                <div Class="project-div">
                    <div className="project-img">
                        <img src={project2} className="proimg" />
                        <video className="proimg hover-img" autoPlay muted loop>
                  		    <source src={video2} type="video/mp4" />
                  	    </video>
                    </div>
                    <button className="pro-tag"><Tag className={classes.Tag} />Design</button>
                    <div className="project-des">
                        <h3 className="des-head">A Web Design Portfolio Layout with svg animations.</h3>
                        <p className="des-link"><a href="https://github.com/Vikalp2502/Web-Design-Portfolio" className="a-link">View on Github <Arrow/></a></p>
                    </div>
                </div>
            </div>
            <div className="portfolio sec-port">
                <div className="project-div">
                    <div className="project-img">
                        <img src={project3} className="proimg" />
                        <video className="proimg hover-img" autoPlay muted loop>
                  		    <source src={video3} type="video/mp4" />
                  	    </video>
                    </div>
                    <button className="pro-tag"><Tag className={classes.Tag} />Development</button>
                    <div className="project-des">
                        <h3 className="des-head">AlgoSort - A Visualizer of all common sorting algorithms.</h3>
                        <p className="des-link"><a href="https://github.com/Vikalp2502/AlgoSort-Sorting-Visualiser" className="a-link">View on Github <Arrow/></a></p>
                    </div>
                </div>
                <div Class="project-div">
                    <div className="project-img">
                        <img src={project4} className="proimg" />
                        <video className="proimg hover-img" autoPlay muted loop>
                  		    <source src={video4} type="video/mp4" />
                  	    </video>
                    </div>
                    <button className="pro-tag"><Tag className={classes.Tag} />Development</button>
                    <div className="project-des">
                        <h3 className="des-head">Shortest PathFinder Visualizer with 4 different algorithms.</h3>
                        <p className="des-link"><a href="https://github.com/Vikalp2502/PathFinding-Visualizer" className="a-link">View on Github <Arrow/></a></p>
                    </div>
                </div>
            </div>
            <div className="portfolio sec-port">
                <div className="project-div">
                    <div className="project-img">
                        <img src={project5} className="proimg" />
                        <video className="proimg hover-img" autoPlay muted loop>
                  		    <source src={video5} type="video/mp4" />
                  	    </video>
                    </div>
                    <button className="pro-tag"><Tag className={classes.Tag} />Development</button>
                    <div className="project-des">
                        <h3 className="des-head">A Sports Landing Page with mouseover effect.</h3>
                        <p className="des-link"><a href="https://github.com/Vikalp2502/Tribute-to-msd" className="a-link">View on Github <Arrow/></a></p>
                    </div>
                </div>
                <div Class="project-div">
                    <div className="project-img">
                        <img src={project6} className="proimg" />
                        <video className="proimg hover-img" autoPlay muted loop>
                  		    <source src={video6} type="video/mp4" />
                  	    </video>
                    </div>
                    <button className="pro-tag"><Tag className={classes.Tag} />Design</button>
                    <div className="project-des">
                        <h3 className="des-head">A Gaming Landing Page with split blur effect.</h3>
                        <p className="des-link"><a href="https://github.com/Vikalp2502/CODM-landing_page" className="a-link">View on Github <Arrow/></a></p>
                    </div>
                </div>
            </div>
            <div className="social-footer">
                <a href="https://github.com/vikalp2502"><button className="social-btn">See more Work 💼</button></a>
            </div>
            </div>
            )}
        </div>
    )
}